import React from 'react';
import PropTypes from 'prop-types';

import { View, StyleSheet } from 'react-native';

import { FormattedMessage } from '@dbk/format';
import Text from '@dbk/ui-text';

import styles from './abbreviated-notes.styles';

function AbbreviatedNotes({ visible }) {
  return visible && (
    <View style={styles.root} accessible={true}>
      <Text secondary>
        <FormattedMessage id={'app.abbreviated.notes'} renderProps={{ style: StyleSheet.flatten(styles.description)}}/>
      </Text>
    </View>
  );
}

AbbreviatedNotes.propTypes = {
  visible: PropTypes.bool,
};

AbbreviatedNotes.defaultProps = {
  visible: true,
};

export default AbbreviatedNotes;
